export default "/images/vendor/flag-icon-css/flags/4x3/ar.svg?fde48cca8a461cc556491b63b81a7f90";